import React, { useState, useRef, useEffect } from 'react';
import { Input, Button, DatePicker, Select, AutoComplete, Radio } from 'antd';
import dayjs from 'dayjs';
const { Option } = Select;
import './DemoForm.scss';
import axios from 'axios';
import { demoHttpUrl } from '../../utils/apiService';

const DemoForm = () => {
    const [birthday, setBirthday] = useState(dayjs(new Date(1999, 0, 1)));
    const [birthdayString, setBirthdayString] = useState('1999-01-01 00:00:00');
    const [gender, setGender] = useState();
    const [apikey, setapikey] = useState();
    const [model_type, setModelType] = useState();
    const [radioValue, setRadioValue] = useState('report');
    const [solar_time, setSolarTime] = useState(false);
    const [loading, setLoading] = useState(false);

    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [selectedData, setSelectedData] = useState(null);
    const [locked, setLocked] = useState(false);
    const fetchTimeout = useRef(null);

    const [link, setLink] = useState('')

    // 🚀 自动防抖搜索出生地
    useEffect(() => {
        if (locked || !inputValue.trim()) return;

        // 清除上一次定时器
        if (fetchTimeout.current) {
            clearTimeout(fetchTimeout.current);
        }

        // 设定新定时器（防抖 500ms）
        fetchTimeout.current = setTimeout(() => {
            axios
                .get(`${demoHttpUrl}/get_country_city_and_like`, {
                    params: { content: inputValue.trim() }
                })
                .then((res) => {
                    const results = res.data.data.map(item => ({
                        label: `${item.city} - ${item.country}`,
                        value: item.city,
                        raw: item
                    }));
                    setOptions(results);
                })
                .catch(console.error);
        }, 500);

        return () => clearTimeout(fetchTimeout.current);
    }, [inputValue, locked]);

    const handleSelect = (value, option) => {
        setInputValue(value); // 输入框设置为城市名
        setSelectedData(option.raw); // 保存完整数据
        setLocked(true); // 锁定输入内容
        setOptions([]); // 清除下拉选项
    };

    const handleSubmit = () => {
        setLoading(true);

        axios.get(demoHttpUrl + '/report_html', {
            params: {
                date: birthdayString,
                gender: gender,
                api_key: apikey,
                lat: selectedData.lat,
                lon: selectedData.long,
                report_type: radioValue,
                model_type: model_type,
                solar_time: solar_time,
            },
            timeout: 360000
        })
            .then(response => {
                setLoading(false);
                // 可处理返回逻辑
                setLink(response.data)
            })
            .catch(error => {
                setLoading(false);
                console.error(error);
            });
    };

    return (
        <div className='demo_form'>
            <div className='horizontal_div'>
                <span className='span_string'>生日:</span>
                <DatePicker
                    showTime
                    className="antd_zujian"
                    value={birthday}
                    onChange={(value, dateString) => {
                        setBirthday(value ? value : null);
                        setBirthdayString(dateString);
                    }}
                />
            </div>

            <div className='horizontal_div'>
                <span className='span_string'>真太阳时:</span>
                <Radio.Group
                    className="antd_zujian"
                    value={solar_time}
                    options={[
                        { value: true, label: '是' },
                        { value: false, label: '否' },
                    ]}
                    onChange={(e) => setSolarTime(e.target.value)}
                />
            </div>

            <div className='horizontal_div'>
                <span className='span_string'>性别:</span>
                <Select
                    className="antd_zujian"
                    placeholder="请选择"
                    value={gender}
                    onChange={(value) => setGender(value)}
                >
                    <Option value="male">男</Option>
                    <Option value="female">女</Option>
                    <Option value="other">其他</Option>
                </Select>
            </div>

            <div className='horizontal_div'>
                <span className='span_string'>出生地:</span>
                <AutoComplete
                    className="antd_zujian"
                    options={options}
                    value={inputValue}
                    notFoundContent={inputValue.trim() && !locked ? '未找到匹配的出生地' : null}
                    onSelect={handleSelect}
                    onChange={(val) => {
                        setInputValue(val);
                        if (!selectedData || val !== selectedData.city) {
                            setLocked(false);
                        }
                    }}
                >
                    <Input placeholder="搜索出生地" />
                </AutoComplete>
            </div>

            <div className='horizontal_div'>
                <span className='span_string'>API Key:</span>
                <Input
                    className="antd_zujian"
                    value={apikey}
                    onChange={(e) => setapikey(e.target.value)}
                    placeholder="请输入 API Key"
                />
            </div>

            <div className='horizontal_div'>
                <span className='span_string'>模型选择:</span>
                <Select
                    className="antd_zujian"
                    placeholder="请选择"
                    value={model_type}
                    onChange={(value) => setModelType(value)}
                >
                    <Option value="models/gemini-2.5-flash-preview-04-17">models/gemini-2.5-flash-preview-04-17</Option>
                    <Option value="gemini-2.5-pro-preview-05-06">gemini-2.5-pro-preview-05-06</Option>
                </Select>
            </div>

            <div className='horizontal_div'>
                <span className='span_string'>报告类型:</span>
                <Radio.Group
                    className="antd_zujian"
                    value={radioValue}
                    options={[
                        { value: 'answer', label: '简短报告' },
                        { value: 'report', label: '完整报告' },
                    ]}
                    onChange={(e) => setRadioValue(e.target.value)}
                />
            </div>

            <div className='horizontal_div'>
                <Button
                    className='submit_button'
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    onClick={handleSubmit}
                    disabled={!birthdayString || !gender || !apikey || !selectedData || !model_type}
                >
                    提交
                </Button>
            </div>
            {radioValue === 'answer' && <div className='horizontal_div' style={{ marginTop: '100px', flexDirection: 'column' }}>
                <span style={{ margin: '10px', lineHeight: '20px', userSelect: 'text' }}> {link} </span>
            </div>}
            {radioValue === 'report' && <div className='horizontal_div' style={{ marginTop: '100px', flexDirection: 'column' }}>
                <a href={link} target="_blank" rel="noopener noreferrer" className='link'>{link}</a>
                <span style={{ marginTop: '10px', }}> 预计十分钟内可生成报告,十分钟后可点击链接查看 </span>
            </div>}
        </div>
    );
};

export default DemoForm;
